import React, { Component } from "react"
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async';
import {
    Container,
    Row,
    Col,
    Spinner,
} from "reactstrap"
import MerchantsList from "./MerchantsList"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../components/Common/withRouter";

// Utilities
import {
    createNotificationHelpers,
    loadMerchantsData,
    transformMerchantsToTableData,
    STORES_TABLE_COLUMNS,
    MESSAGES
} from "../utils";

class Stores extends Component {
    constructor(props) {
        super(props)

        // Parse search query parameter from URL
        const searchParam = this.getSearchFromLocation(props.location);

        this.state = {
            TotalMerchants: 0,
            MerchantsDetails: 0,
            loading: false,
            search: searchParam
        }

        // Initialize notification helpers
        const notifications = createNotificationHelpers();
        this.notify_info = notifications.notify_info;
        this.notify_error = notifications.notify_error;
        this.notify_success = notifications.notify_success;
    }

    /**
     * Extracts search query parameter from location
     */
    getSearchFromLocation = (location) => {
        if (!location?.search) return '';
        const params = new URLSearchParams(location.search);
        return params.get('q') || '';
    }

    /**
     * Navigates to merchant details page
     */
    navigateToMerchantDetails = (merchant) => {
        this.props.navigate("/merchant-details", {
            state: {
                data: merchant,
                storeStatus: 'active'
            }
        });
    }

    /**
     * Loads merchants from API and updates state
     */
    loadMerchants = async () => {
        const merchants = await loadMerchantsData(this.state.search, this.notify_error);

        if (merchants && Array.isArray(merchants)) {
            const table_records = transformMerchantsToTableData(
                merchants,
                STORES_TABLE_COLUMNS,
                this.navigateToMerchantDetails
            );

            this.setState({
                TotalMerchants: merchants.length,
                MerchantsDetails: table_records,
                loading: true
            });

            this.notify_success(MESSAGES.STORES_LOADED_SUCCESS);
        } else {
            // Set loading to true even if no data to show empty state
            this.setState({
                loading: true,
                MerchantsDetails: { columns: STORES_TABLE_COLUMNS, rows: [] }
            });
        }
    }

    componentDidMount() {
        this.loadMerchants();
    }

    componentDidUpdate(prevProps) {
        // Reload merchants when location search parameter changes
        const prevSearch = this.getSearchFromLocation(prevProps.location);
        const currentSearch = this.getSearchFromLocation(this.props.location);

        if (prevSearch !== currentSearch) {
            // Update search state and reload merchants
            this.setState({
                search: currentSearch,
                loading: false
            }, () => {
                this.loadMerchants();
            });
        }
    }

    /**
     * Renders the loading spinner
     */
    renderLoadingSpinner = () => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px' }}>
            <Spinner color="primary" />
            <span style={{ marginLeft: '10px' }}>Loading ...</span>
        </div>
    )

    render() {
        const { MerchantsDetails, loading, search } = this.state;
        const { t } = this.props;

        return (
            <React.Fragment>
                <div className="page-content">
                    <Helmet>
                        <title>Veeper | AP - Stores</title>
                    </Helmet>
                    <Container fluid>
                        <Breadcrumbs
                            title={t("Stores")}
                            breadcrumbItem={t(`Stores [${search || 'All'}]`)}
                        />
                        <ToastContainer />
                        <Row>
                            <Col xl={12}>
                                {loading ? (
                                    <MerchantsList data={MerchantsDetails} default_entries={200} />
                                ) : (
                                    this.renderLoadingSpinner()
                                )}
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

Stores.propTypes = {
    t: PropTypes.any,
    location: PropTypes.object,
    navigate: PropTypes.func
}

export default withRouter(withTranslation()(Stores))
